import BaseApi, { ServerListRequest, ServerListResponse } from '@lumapps/base-api';
import { GRANT_TYPE, ObjectValues } from '@lumapps/marketplace/sdk';

import { MAX_RESULTS_AVAILABLE_CONNECTOR_LIST } from '../constants';
import { Connector } from '../types';

const baseApi = new BaseApi({ version: BaseApi.versions.v2 });

export interface ListAvailableConnectorsParams extends Pick<ServerListRequest, 'cursor' | 'maxResults'> {
    /** grand type of the connectors needed */
    grantType?: ObjectValues<typeof GRANT_TYPE>;
    /** integration is include */
    includeIntegration: boolean;
}

/**
 * Retreive the list of available connectors.
 *
 * @param {Object} params
 * @returns Promise<Connector>
 */
export const listAvailableConnectors = ({
    maxResults = MAX_RESULTS_AVAILABLE_CONNECTOR_LIST.toString(),
    ...restParams
}: ListAvailableConnectorsParams) => {
    return baseApi.get<ServerListResponse<Connector>>('available-connectors', {
        params: { maxResults, ...restParams },
    });
};
